module.exports = __webpack_public_path__ + "img/laufenn.d3219a32.svg";